import { useEffect, useState } from "react";
import ButtonWithLoader from "../../../../common/components/ui/loading/ButtonLoading";
import { InfoTable } from "../../../../common/components/ui/table/InfoTable";
import { VEHICLE_STATUS } from "../../../../types/vehicle.type";
import { useVehicleDashboardContext } from "../vehicle-dashboard/useVehicleDashboardContext";
import { savePublickLink } from "../../../../common/services/vehicles.api";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";
import VehicleBlockToggle from "../../../renters/components/forms/fields/VehicleBlockToggle";

export interface IVehicleLinkResponse {
  createtime: number;
  iddevice: string;
  iduser: string;
  link: string;
  original_validtime: null | number;
  token: string;
  validtime: number;
}

const STATUS_LABELS = {
  [VEHICLE_STATUS.AVAILABLE]: "Disponível",
  [VEHICLE_STATUS.MISSING_DATA]: "Dados incompletos",
  [VEHICLE_STATUS.RENTED]: "Locado",
  [VEHICLE_STATUS.INACTIVE]: "Inativo",
  [VEHICLE_STATUS.WAITING_PAYMENT]: "Aguardando pagamento",
  [VEHICLE_STATUS.SELLED]: "Veículo vendido",
  [VEHICLE_STATUS.UNDER_PREPARATION]: "Em preparação",
  [VEHICLE_STATUS.UNDER_REVIEW]: "Revisão Programada",
  [VEHICLE_STATUS.IN_REPAIR]: "Em manutenção",
  [VEHICLE_STATUS.IN_REVISION]: "Reparo estético",
  [VEHICLE_STATUS.INSURANCE]: "Abertura de acionamento",
  [VEHICLE_STATUS.IMPOUNDED]: "Apreendido",
  [VEHICLE_STATUS.THIRD_PARTY_INSURANCE]: "Seguro de Terceiros",
  [VEHICLE_STATUS.PREPARATION_FOR_SALE]: "Motos para Venda",
  [VEHICLE_STATUS.IN_TRANSIT]: "Em trânsito",
  [VEHICLE_STATUS.THEFT_ROBBERY]: "Furto/Roubo",
  [VEHICLE_STATUS.MISAPPROPRIATION]: "Apropriação indébita",
  [VEHICLE_STATUS.VEHICLE_ON_RESERVED]: "Moto reserva",
  [VEHICLE_STATUS.TRIGGER_OPENING]: "Proteção acionada",
  [VEHICLE_STATUS.REIMBURSEMENT]: "Aguard. Ressarcimento",
  [VEHICLE_STATUS.TRIAGE]: "Triagem",
};

// eslint-disable-next-line react-refresh/only-export-components
export function getStatusLabels(status: VEHICLE_STATUS) {
  return STATUS_LABELS[status] || status;
}

export function InfoVehicleBlock() {
  const { vehicle } = useVehicleDashboardContext();
  const [bindVelotrackInProgress, setBindVelotrackInProgress] = useState(false);
  const [publicLink, setPublicLink] = useState("");
  const [vehicleBlock, setVehicleBlock] = useState(
    vehicle.velotrackSettings?.blocked ?? false
  );
  const { notifySuccess, notifyError } = useToastContext();

  useEffect(() => {
    setVehicleBlock(vehicle.velotrackSettings?.blocked ?? false);
  }, [vehicle.velotrackSettings?.blocked, vehicleBlock]);

  async function handlePublicLinkVelotrack() {
    try {
      setBindVelotrackInProgress(true);
      const result = await savePublickLink(vehicle);
      if (!result.ok) {
        notifyError("Veiculo não encontrado na Velotrack");
        return;
      }

      setPublicLink(result.data.link); // Salva o link no estado
      notifySuccess("Veículo encontrado na Velotrack!");
    } catch (err) {
      console.log(err);
    } finally {
      setBindVelotrackInProgress(false);
    }
  }

  const handleStatusChange = () => {
    setVehicleBlock(vehicle.velotrackSettings.blocked ?? false);
  };

  return (
    <div>
      <InfoTable
      title="Informações do Veículo"
      data={[
        { label: "Placa", value: vehicle.licensePlate },
        { label: "Status", value: getStatusLabels(vehicle.status) },
        { label: "Situação", value: vehicle.vehicleSituation },
        { label: "Renavam", value: vehicle.renavam },
        { label: "Ano", value: vehicle.yearModel },
        { label: "UF", value: vehicle.uf },
      ]}
      toogle={
        <div>
        <VehicleBlockToggle
          vehicleId={vehicle._id}
          initialVehicleBlockStatus={vehicleBlock}
          onStatusChange={handleStatusChange}
        />
        </div>
      }
      button={
        <div>
        <div className="flex flex-col gap-4">
          <h2 className="font-bold text-[18px]">
          Acompanhamento de veículo em tempo real{" "}
          </h2>
          <div className="flex items-center justify-between">
          <ButtonWithLoader
            type="button"
            isLoading={bindVelotrackInProgress}
            onClick={handlePublicLinkVelotrack}
          >
            Gerar link
          </ButtonWithLoader>
          {publicLink && (
            <a
            href={publicLink}
            target="_blank"
            rel="noopener noreferrer"
            className="ml-2 text-bluePrimary hover:underline"
            >
            Acompanhar
            </a>
          )}
          </div>
        </div>
        </div>
      }
      />
      {vehicle.filesSale && (
      <div className="mt-4">
        <a
        href={Array.isArray(vehicle.filesSale) 
          ? `https://assets.locavibe.com.br/${vehicle.filesSale[0]}`
          : `https://assets.locavibe.com.br/${vehicle.filesSale}`}
        target="_blank"
        rel="noopener noreferrer"
        className="text-bluePrimary hover:underline"
        >
        Documento de Ressarcimento
        </a>
      </div>
      )}
    </div>
  );
}
